import shadows from '../shadows';

const muiPaperOverrides = {
  styleOverrides: {
    root: {
      border: 'none',
    },
    elevation1: {
      boxShadow: shadows.paper,
    },
  },
};

export default muiPaperOverrides;
